import { createAction } from '@reduxjs/toolkit';
import { Category, Component } from '@Types';

export const getCoFComponentsResolved = createAction<Category[]>(
	'CoF/getCoFComponentsResolved',
);
export const getCoFComponentsRejected = createAction(
	'CoF/getCoFComponentsRejected',
);

export const addCoFConfig = createAction<Category>('CoF/addCoFConfig');
export const setCoFConfig = createAction<Category[]>('CoF/setCoFConfig');

export const getCoFFields = createAction<string>('CoF/getCoFFields');
export const getCoFFieldsResolved = createAction<Category[]>(
	'CoF/getCoFFieldsResolved',
);
export const getCoFFieldsRejected = createAction('CoF/getCoFFieldsRejected');

export const getProximityAttributeFields = createAction<string>(
	'ProximityAttribute/getProximityAttributeFields',
);
export const getProximityAttributeFieldsResolved = createAction<Category[]>(
	'ProximityAttribute/getProximityAttributeFieldsResolved',
);
export const getProximityAttributeFieldsRejected = createAction(
	'ProximityAttribute/getProximityAttributeFieldsRejected',
);

export const getCustomTableFields = createAction<string>(
	'CustomTable/getCustomTableFields',
);
export const getCustomTableFieldsResolved = createAction<Category[]>(
	'CustomTable/getCustomTableFieldsResolved',
);
export const getCustomTableFieldsRejected = createAction(
	'CustomTable/getCustomTableFieldsRejected',
);

export const addCoFComponent = createAction<{
	categoryName: string;
	component: Component;
}>('CoF/addCoFComponent');
export const setCoFComponent = createAction<{
	categoryName: string;
	componentName: string;
	component: Component;
}>('CoF/setCoFComponent');
export const setCoFComponents = createAction<{
	categoryName: string;
	components: Component[];
}>('CoF/setCoFComponents');

export const saveCoF = createAction<{
	refresh: () => void;
}>('CoF/saveCoF');
export const saveCoFResolved = createAction('CoF/saveCoFResolved');
export const saveCoFRejected = createAction('CoF/saveCoFRejected');

export const deleteCoFCategory = createAction<{
	forLoF: boolean;
	categoryName: string;
}>('CoF/deleteCoFCategory');

export const setCoFIsChanged = createAction<boolean>('CoF/setCoFIsChanged');
